import React from 'react';
import './Timeline.css';

export default function Timeline({ user, repos }) {
  const joinYear = new Date(user.created_at).getFullYear();
  const now = new Date().getFullYear();

  const yearMap = {};
  repos.forEach(r => {
    const y = new Date(r.created_at).getFullYear();
    if (!yearMap[y]) yearMap[y] = 0;
    yearMap[y]++;
  });

  const years = [];
  for (let y = joinYear; y <= now; y++) {
    years.push({ year: y, count: yearMap[y] || 0 });
  }

  const maxCount = Math.max(...years.map(y => y.count), 1);

  return (
    <div className="timeline card">
      <div className="card__label">Repository timeline</div>
      <div className="timeline__bars">
        {years.map((y, i) => (
          <div className="timeline__col" key={y.year}>
            <div className="timeline__bar-wrap">
              <div
                className="timeline__bar"
                style={{
                  height: `${Math.max((y.count / maxCount) * 100, y.count > 0 ? 8 : 2)}%`,
                  animationDelay: `${i * 40}ms`,
                }}
                title={`${y.count} repo${y.count !== 1 ? 's' : ''}`}
              />
            </div>
            <span className="timeline__year">
              {y.year === joinYear ? (
                <span className="timeline__start">joined</span>
              ) : String(y.year).slice(2)}
            </span>
          </div>
        ))}
      </div>
      <div className="timeline__legend">
        <span className="timeline__legend-dot" />
        <span className="timeline__legend-text">repos created per year</span>
      </div>
    </div>
  );
}
